import { render, staticRenderFns } from "./new_04.vue?vue&type=template&id=1f38c62f&scoped=true"
import script from "./new_04.vue?vue&type=script&lang=js"
export * from "./new_04.vue?vue&type=script&lang=js"
import style0 from "./new_04.vue?vue&type=style&index=0&id=1f38c62f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f38c62f",
  null
  
)

export default component.exports